import { render, staticRenderFns } from "./ClassificationDocumentsView.vue?vue&type=template&id=07c68982&scoped=true"
import script from "./ClassificationDocumentsView.vue?vue&type=script&lang=js"
export * from "./ClassificationDocumentsView.vue?vue&type=script&lang=js"
import style0 from "./ClassificationDocumentsView.vue?vue&type=style&index=0&id=07c68982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c68982",
  null
  
)

export default component.exports